import isEmpty from 'lodash/isEmpty';
import split from 'lodash/split';

/**
 * Custom hook to build slides array from various media sources
 * @param {Object} params - Parameters for building slides
 * @returns {Array} Array of slide objects
 */
const useSlideBuilder = ({
  cover,
  coverAltText,
  name,
  videos,
  bundleVideos,
  bundleImages,
  screenshots,
  ageGateRequired,
  unlinkCoverFromVideo,
}) => {
  const sliderVideos = videos.map(video => ({
    video: true,
    src: video.src,
    cover: video.cover,
  }));

  const sliderBundleVideos = bundleVideos.map(video => ({
    video: true,
    src: video.src,
    cover: video.cover,
  }));

  let useCoverForFirstVideo = true;
  if (isEmpty(sliderVideos) || ageGateRequired || unlinkCoverFromVideo) {
    useCoverForFirstVideo = false;
  }

  const slides = [];

  // Add cover slide
  if (cover && !useCoverForFirstVideo) {
    let alt = split(cover, '.')[0];
    if (coverAltText) alt = coverAltText;
    slides.push({
      image: cover,
      alt,
      type: 'cover',
      number: slides.length + 1,
      order: '0',
      cover: true,
    });
  }

  // Add video slides
  if (!isEmpty(sliderVideos) && !ageGateRequired) {
    sliderVideos.forEach((video, i) => {
      let alt = split(video.cover, '.')[0];
      let useYouTubeCover = true;
      if (useCoverForFirstVideo && i === 0) {
        useYouTubeCover = false;
        alt = `Product cover for ${name}`;
        if (coverAltText) alt = coverAltText;
      }

      slides.push({
        image: video.cover,
        alt,
        type: 'video',
        number: slides.length + 1,
        order: '0',
        video: video.src,
        ytCover: useYouTubeCover,
      });
    });
  }

  // Add bundle video slides
  if (!isEmpty(sliderBundleVideos)) {
    sliderBundleVideos.forEach((video) => {
      const alt = split(video.cover, '.')[0];
      slides.push({
        image: video.cover,
        alt,
        type: 'bundle-video',
        number: slides.length + 1,
        order: '0',
        video: video.src,
      });
    });
  }

  // Add bundle image slides
  if (!isEmpty(bundleImages)) {
    bundleImages.forEach((image, i) => {
      slides.push({
        image: image.slug,
        alt: image.alt,
        type: 'image',
        number: slides.length + 1,
        screenshotNumber: i + 1,
        order: image.order || '99',
      });
    });
  }

  // Add screenshot slides
  if (!isEmpty(screenshots)) {
    screenshots.forEach((image, i) => {
      slides.push({
        image: image.slug,
        alt: image.alt,
        type: 'image',
        number: slides.length + 1,
        screenshotNumber: i + 1,
        order: image.order || '99',
      });
    });
  }

  return slides;
};

export default useSlideBuilder;
